import {
    STROLLERS_CHARTS_BY_PROFILE_COUNT_HEADING,
    STROLLERS_CHARTS_BY_USER_SCORE_DESCRIPTION,
    STROLLERS_CHARTS_BY_USER_SCORE_HEADING,
} from 'mk/autogenerated/translations/Charts.652c7af0c001c161dd0d644f3ec1aa94'
import { ChartListItem, ChartListItemPlaceholder } from 'mk2/apps/strollers/components/ChartListItem';
import { Props } from 'mk2/apps/strollers/containers/Charts/ChartsPage';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import React from 'react';
import styles from './Charts.mscss';

export class Charts extends React.Component<Props> {
    public render() {
        const { strollersByUserScore, strollersByProfileCount, loadingState } = this.props;

        return (
            <div className={styles.Charts}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.onLoad}
                    onRenderInit={this.onRenderInit}
                    onRenderSuccess={this.onRenderSuccess}
                    hasData={Boolean(strollersByUserScore.length + strollersByProfileCount.length)}
                />
            </div>
        );
    }

    private onRenderInit = () => {
        return (
            <>
                <h2 className={styles.Charts__heading}>{STROLLERS_CHARTS_BY_USER_SCORE_HEADING}</h2>
                <p className={styles.Charts__description}>{STROLLERS_CHARTS_BY_USER_SCORE_DESCRIPTION}</p>

                <div className={styles.Charts__list}>
                    {Array.from(Array(10).keys()).map((index) => (
                        <ChartListItemPlaceholder
                            position={index + 1}
                            key={index}
                            className={styles.Charts__list__item}
                        />
                    ))}
                </div>

                <h2 className={styles.Charts__heading}>{STROLLERS_CHARTS_BY_PROFILE_COUNT_HEADING}</h2>

                <div className={styles.Charts__list}>
                    {Array.from(Array(10).keys()).map((index) => (
                        <ChartListItemPlaceholder
                            position={index + 1}
                            key={index}
                            className={styles.Charts__list__item}
                        />
                    ))}
                </div>
            </>
        );
    };

    private onRenderSuccess = () => {
        const { strollersByUserScore, strollersByProfileCount } = this.props;

        return (
            <>
                <h2 className={styles.Charts__heading}>{STROLLERS_CHARTS_BY_USER_SCORE_HEADING}</h2>
                <p className={styles.Charts__description}>{STROLLERS_CHARTS_BY_USER_SCORE_DESCRIPTION}</p>

                <div className={styles.Charts__list}>
                    {strollersByUserScore.map((stroller, index) => (
                        <ChartListItem
                            position={index + 1}
                            key={stroller.id}
                            stroller={stroller}
                            className={styles.Charts__list__item}
                        />
                    ))}
                </div>

                <h2 className={styles.Charts__heading}>{STROLLERS_CHARTS_BY_PROFILE_COUNT_HEADING}</h2>

                <div className={styles.Charts__list}>
                    {strollersByProfileCount.map((stroller, index) => (
                        <ChartListItem
                            position={index + 1}
                            key={stroller.id}
                            stroller={stroller}
                            className={styles.Charts__list__item}
                        />
                    ))}
                </div>
            </>
        );
    };

    private onLoad = () => {
        this.props.onLoad();
        this.props.onStrollersComparisonLoad();
    };
}
